export const AUTH_REQUEST = 'AUTH_REQUEST';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_ERROR = 'AUTH_ERROR';
export const AUTH_ADD_URL_TO_REQUEST = 'AUTH_ADD_URL_TO_REQUEST';
export const AUTH_ADD_URL_TO_SUCCESS = 'AUTH_ADD_URL_TO_SUCCESS';
export const AUTH_ADD_URL_TO_ERROR = 'AUTH_ADD_URL_TO_ERROR';
export const LOGOUT = 'LOGOUT';
